"use client";

import React from "react";
import { RotateCcw, UserRoundSearch } from "lucide-react";
import { useRouter } from "next/navigation";
import { SuggestionCardGroupProps } from "./SuggestionCardGroup.types";
import "./SuggestionCardGroup.css";

function SuggestionCardGroup<T extends { id: number }>({
  title,
  suggestions,
  onRefresh,
  onClickItem,
  renderItem,
  subtitle,
}: SuggestionCardGroupProps<T>) {
  const router = useRouter();

  return (
    <div className="suggestion-card-group">
      <div className="suggestion-card-group__header">
        <h3 className="suggestion-card-group__title" title={subtitle}>
          {title}
        </h3>
        <button className="suggestion-card-group__refresh" onClick={onRefresh}>
          <RotateCcw size={18} />
        </button>
      </div>

      {suggestions.length === 0 ? (
        <div className="suggestion-card-group__empty">
          <UserRoundSearch size={36} />
          <p>It&apos;s a bit quiet here. New suggestions may appear as you engage more.</p>
        </div>
      ) : (
        <div className="suggestion-card-group__list">
          {suggestions.map((item) => (
            <div className="suggestion-card-group__item" key={item.id}>
              {renderItem ? (
                renderItem(item)
              ) : (
                <>
                  <img
                    src={(item as any).avatar_url}
                    alt={(item as any).username}
                    className="suggestion-card-group__avatar"
                    onClick={() =>
                      (item as any).profile_url
                        ? router.push((item as any).profile_url)
                        : onClickItem?.(item.id)
                    }
                  />
                  <span className="suggestion-card-group__username">
                    {(item as any).username}
                  </span>
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SuggestionCardGroup;
